export default {
  computed: {
    fetchSettings() {
      const convert = this.settings;
      return convert;
    },
    fetchSettingsOne() {
      const convert = this.settings;
      return convert.data[0];
    },
    sectionSelected() {
      //@Todo: Refactor this method to separate concerns, since it is mixed with the landing page generator
      if (this.isAdminPanelSectionBlocks()) {
        return this.$store.getters['block/searchBlockById'](this.id);
      }

      if (this.isAdminPanelSectionBlock()) {
        return this.$store.getters['block/findBlockById'](this.id);
      }

      return this.$store.getters['section/findSectionById'](this.sectionId).blocks[this.blockIndex];
    }
  },
  props: [
    'sectionId',
    'id',
    'blockIndex',
    'title',
    'settings',
    'sectionName',
    'sectionTextColor',
    'theme',
    'block'
  ],
  methods: {
    isAdminPanelSectionBlocks() {
      return (this.$route.name.includes("core/section/edit") || this.$route.name.includes("preview"))
    },
    isAdminPanelSectionBlock() {
      return (this.$route.name.includes("core/section/block") || this.$route.name.includes("preview"))
    },
    componentGlobalLoader(componentName) {
      try {
        return require(`@fremcast/section/${componentName}`).default;
      } catch(e) {
        return null;
      }
    }
  }
}
